import { NavItemProps } from '../@types/general';

export const fallbackImagePath = '/images/ImageError.jpg';

export const ROUTE = {
  home: '/',
  createAccount: '/create-account',
  signin: '/sign-in',
  account: '/account',
  upgrade: '/upgrade',
  forgotPassword: '/forgot-password',
  billing: '/account/billing',
  subscription: '/account/subscription',
  myProfile: '/account/profile',
  resetPassword: '/reset-password',
  leads: '/leads',
  noLead: '/nolead',
  projectProfile: '/project/:id/profile',
  projectInformation: '/project/:id/information',
  projectTracking: '/project/:id/tracking',
  projectMeasurement: '/project/:id/measurement',
  projectFinal: '/project/:id/final',
  verify: '/user/verify',
  leadId: ':leadId',
  project: 'project',
  property: 'property',
  personal: 'personal',
  designAssistant: 'design-assistant',
};

export const rwproPasswordResetRedirectURL = '/pages/account/reset?resetKey={{reset_key}}&lang=en';

// TODO: custom reset flow with new query param if redirect to rwpro site is insufficient
export const redirectUrl = `${ROUTE.resetPassword}?resetKey={{reset_key}}`;

export const secondaryNavItems: NavItemProps[] = [
  { label: 'navigation.projectInformation', href: 'project' },
  {
    label: 'navigation.propertyInformation',
    href: 'property',
  },
  {
    label: 'navigation.personalInformation',
    href: 'personal',
  },
  // Temporarily hidden for future use: Design Assistant tab
  // {
  //   label: 'navigation.designAssistant',
  //   href: 'design-assistant',
  // },
];

export enum SUBSCRIPTION {
  BASIC,
  PRO,
}
